import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OptionSelectorService {

  initialState: any = {}

  public onHide = new Subject<any>();
  public onOpen = new Subject<any>();

  constructor() {
    this.initialState = {
      list: [],
      open: false,
      index: 0
    };
  }

  open(initialState) {
    this.initialState.list = initialState.list;
    this.initialState.open = true;
    this.initialState.index = initialState.index;
    this.onOpen.next(this.initialState);
  }

  hide(l) {
    this.onHide.next({ index: this.initialState.index, data: l });
    this.initialState.open = false;
  }
}
